import PropTypes from 'prop-types';
import OwlCarousel from 'react-owl-carousel';

const internals = {};

internals.numberWords = {
  1: 'one',
  2: 'two',
  3: 'three',
  4: 'four',
  5: 'five',
  6: 'six',
  7: 'seven',
  8: 'eight'
};
internals.sliderExtravagant = {
  nav: false,
  dots: true,
  navText: false,
  items: 1,
  lazyLoad: true,
  animateOut: 'fadeOut',
  touchDrag: false,
  mouseDrag: false
};

export default class SimpleExtravagant extends React.Component {
  static propTypes = {
    inspirationID: PropTypes.number,
    inspirationName: PropTypes.string,
    inspirationSimpleExtravagantImgs: PropTypes.array,
    updateExtravagantSlider: PropTypes.func
  };

  constructor() {
    super();
    this.countRender = 0;
    this.state = {
      isSuggestionOpen: true,
      activeSlide: 0
    };
  }

  componentDidUpdate() {
    this._onSliderDotClick();
  }

  _onSliderDotClick = () => {
    $('.slideshow-img-wrapper .owl-dots').on('click', '.owl-dot', (e) => {
      const navContainerChildren = Array.from(e.currentTarget.parentNode.children);
      const slideIndex = navContainerChildren.indexOf(e.currentTarget);
      const slider = document.querySelector('.owl-extravagant');
      const captions = Array.from(slider.querySelectorAll('.section-txt'));
      const simpleBulletText = document.querySelector('.bullet-txt.simple');
      const extravagantBulletText = document.querySelector('.bullet-txt.extravagant');
      const totalSlides = navContainerChildren.length - 1;

      if (slideIndex > 0 && slideIndex < totalSlides && simpleBulletText.classList.contains('highlighted')) {
        simpleBulletText.classList.remove('highlighted');
        extravagantBulletText.classList.remove('highlighted');
      } else if (slideIndex === 0 && !simpleBulletText.classList.contains('highlighted')) {
        simpleBulletText.classList.add('highlighted');
        extravagantBulletText.classList.remove('highlighted');
      } else if (slideIndex === totalSlides && !extravagantBulletText.classList.contains('highlighted')) {
        simpleBulletText.classList.remove('highlighted');
        extravagantBulletText.classList.add('highlighted');
      }

      for(const caption of captions) {
        caption.classList.add('hide');
      }
      captions[slideIndex].classList.remove('hide');
    });
  };

  _closeSuggestionHandler = () => this.setState({ isSuggestionOpen: !this.state.isSuggestionOpen });

  _renderImages = (images) => {
    return images.map((image, index) => {
      return(
        <div className="section" data-section={`${index + 1}`} key={ index }>
          <img className="img-responsive use-attributes slideshow-img owl-lazy" data-src={image} alt=""/>
        </div>
      );
    });
  };

  _renderCaptions = (caption, index, imageArraySize) => {
    return (
      <section key={`${caption}-${index}`} className={`section-txt arial section-${index + 1} ${(index + 1 > 1) ? 'hide' : ''}`}>
        <span className="counter">{`${index + 1}/${imageArraySize}`}</span>
        <span className="txt-left slideshow-caption">{`${caption} `}<span className="wddng-colored">{` - Table Setup ${index + 1}`}</span></span>
      </section>
    );
  };

  render() {
    const {inspirationSimpleExtravagantImgs, inspirationName} = this.props;
    const imageArraySize = inspirationSimpleExtravagantImgs.length;
    const imagesToDisplay = this._renderImages(inspirationSimpleExtravagantImgs);

    if (!this.props.inspirationSimpleExtravagantImgs || this.props.inspirationSimpleExtravagantImgs.length === 0 || this.props.inspirationID === 0) {
      return (
        <strong>Error: Images must be added on json file for both simple to Ext and Main slider</strong>
      );
    }

    const numberDots = internals.numberWords[this.props.inspirationSimpleExtravagantImgs.length];

    return(
      <div>
        <input type="checkbox" id="simpleExt" />
        <section className="simple-to-extravagant-panel pr">
          <div className="slideshow-container pr">
            <div className="row center-xs img-nav container">
              <span className={`xs-6 lg-3 bullet-txt arial simple ${(this.state.activeSlide === 0) ? 'highlighted' : '' }`}>FROM SIMPLE</span>
              <div className="bullets-wrapper pr lg-5 hidden-large-down"/>
              <span className={`xs-6 lg-4 bullet-txt arial extravagant ${(this.state.activeSlide === (inspirationSimpleExtravagantImgs.length - 1)) ? 'highlighted' : '' }`}>TO EXTRAVAGANT</span>
              <div className="bullets-wrapper mobile pr xs-12 hidden-large-up"/>
            </div>
            <div className="owl-extravagant container pr">
              <label htmlFor="simpleExt" onClick={ this.props.updateExtravagantSlider } className="close-simple-extravagant pa hidden-large-down"><i className="icon-close" /></label>
              <OwlCarousel {...internals.sliderExtravagant} className={`slideshow-img-wrapper owl-theme ${numberDots}-dots`} >
                { imagesToDisplay }
              </OwlCarousel>
              { inspirationSimpleExtravagantImgs.map((image, index) => this._renderCaptions(inspirationName, index, imageArraySize)) }
            </div>
          </div>
        </section>
      </div>
    );
  }
}
